import React from 'react';
import { Typography } from '@mui/material';
import SettingsCard from '../components/SettingsCard';

const GroupsSettings = () => {
  return (
    <SettingsCard title="Grupos">
      <Typography color="text.secondary">
        Sección en desarrollo
      </Typography>
    </SettingsCard>
  );
};

export default GroupsSettings;